import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=2f6f91b4&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=2f6f91b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f91b4",
  null
  
)

export default component.exports